import React from 'react';
import { SimpleGraph } from '@gerdau/hefesto-mais-web/SimpleGraph';
import { Title, Select, Skeleton } from '@gerdau/hefesto';
import { TargetContainer } from './styles';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { TSelectOptionProps } from '@gerdau/hefesto/Select/Select.types';
import {
  IMonthlyCoins,
  IMonthlyGoal
} from '../../../../../store/ducks/loyalty/types';

interface ITargetCoinsProps {
  selectedMonthIdx: number;
  onChangeSelectedMonthIdx: (newIdx: number) => void;
  selectedRewardMonth?: IMonthlyCoins;
  selectedGoalMonth?: IMonthlyGoal;
}

const TargetCoins: React.FC<ITargetCoinsProps> = ({
  selectedMonthIdx,
  onChangeSelectedMonthIdx,
  selectedRewardMonth,
  selectedGoalMonth
}) => {
  const loyalty = useSelector((appState: ApplicationState) => appState.loyalty);

  const lastUpdate = 'Atualizado em ' + new Date().toLocaleDateString('pt-BR');

  const getPercentage = (): number => {
    if (!selectedRewardMonth || !selectedGoalMonth) {
      return 0;
    }
    return (selectedRewardMonth.coins / selectedGoalMonth.target) * 100;
  };

  const baseData = loyalty.rewards.monthly_coins.map((item) => {
    const parsedDate = new Date(item.start_date);
    const monthInitials = format(parsedDate, 'MMMM', { locale: ptBR });

    return {
      month: monthInitials,
      value: item.coins,
      order: parsedDate
    };
  });

  const baseDataSorted = [...baseData]
    .sort(
      (a: (typeof baseData)[0], b: (typeof baseData)[0]) =>
        a.order.getTime() - b.order.getTime()
    )
    .slice(-5);
  const targets: TSelectOptionProps[] = baseDataSorted.map((item, index) => {
    const Target: TSelectOptionProps = {
      label: item.month,
      value: index?.toLocaleString()
    };
    return Target;
  });

  const formatTon = (reward: number | undefined) => {
    if (!reward) {
      return '0';
    }
    if (reward % 10 === 0) {
      return reward.toLocaleString('pt-BR');
    }
    return reward.toFixed(3).replace('.', ',');
  };

  return (
    <TargetContainer>
      <div className="monthly-goal">
        <div className="target-title">
          <Title level={3}>Meta mensal</Title>
        </div>
        <div className="month-selector">
          <Select
            name="Select"
            dropdownPosition="bottom"
            options={targets}
            label={''}
            value={selectedMonthIdx.toString()}
            onSelect={(value: string | string[]) => {
              onChangeSelectedMonthIdx(Number(value));
            }}
          />
        </div>
        <div className="line">
          <hr />
        </div>

        {loyalty.goal.loading ? (
          <div className="graph-skeleton">
            <Skeleton type="title" />
            <Skeleton type="title" />
          </div>
        ) : (
          <>
            <div className="simple-graph">
              <SimpleGraph percentage={getPercentage()}>
                {`${formatTon(selectedRewardMonth?.coins)} toneladas`}
              </SimpleGraph>
            </div>
            <div className="graph-label">
              <span className="label-left">{lastUpdate}</span>
              <span className="label-right">
                {`${formatTon(selectedRewardMonth?.coins)} / ${formatTon(
                  selectedGoalMonth?.target
                )} toneladas`}
              </span>
            </div>
          </>
        )}
      </div>
    </TargetContainer>
  );
};

export default TargetCoins;
